import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import core from "../core/core.module";
import param from "./param";
import paramForm from "./param-form/param-form";

angular
    .module('paramsControl.component', [angularUIB, param, core, paramForm])
    .component('paramsControl', {
        template: require('./params-control.component.html'),
        controller: ['Param', 'notifier', '$uibModal', controller],
        bindings: {

        }
    });

function controller(Param, notifier, $uibModal) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.currentPage = 1;
        $ctrl.search = null;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.clearFilter = function () {
        $ctrl.currentPage = 1;
        $ctrl.search = null;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        Param
            .getList({
                currentPage: $ctrl.currentPage,
                search: $ctrl.search
            })
            .then(
                function (response) {
                    $ctrl.params = response.data.params;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.openForm = function (param) {
        $uibModal
            .open({
                component: 'paramForm',
                resolve: {
                    param: function () {
                        return param;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    if (!param) {
                        $ctrl.params.push(result);
                    } else {
                        param.key = result.key;
                        param.description = result.description;
                        param.value = result.value;
                    }
                },
                function () {

                }
            );
    };

    $ctrl.deleteParam = function (param, ind) {
        if (!confirm('Вы действительно хотите удалить параметр?')) {
            return;
        }
        Param.destroy(param.key).then(
            function (response) {
                $ctrl.params.splice(ind, 1);
                notifier.successNotify('Параметр успешно удален');
            },
            function (error) {
                notifier.errorResponseNotify(error);
            }
        )
    };

}

export default 'paramsControl.component';


// WEBPACK FOOTER //
// ./resources/assets/modules/params-control/params-control.component.js